import React from "react";
import { Routes, Route, } from "react-router-dom";
import {IdentificationVerificationVersionRouter} from "./versions/version-router";
import { IdentityDraft } from "./versions/v1/pages/identity-draft";
import { ArchiveSummary } from "./archive/components/pages/archive-summary";

export const IdentificationVerificationRouter: React.FC = () => {
  
  return (
    <Routes>
      <Route path="archived/*" element={<ArchiveSummary/>} />
      <Route
        path="active/*"
        element={<IdentificationVerificationVersionRouter />}
      />
      {/* Route for creating a new identity verification draft */}
      <Route
        path="draft/*"
        element={<IdentityDraft/>}
      />
    </Routes>
  );
};

